import {useState} from "react";
import {ModalSize, SimpleModal} from "../../SimpleModal";
import * as S from './styles'

import SupportImage from '../../../assets/images/ab_support_image.png';
import QRCode from '../../../assets/images/ab_qr_code.png'
import {Button} from "../../Button";
import {Text1} from "../../../styles/components";
import {FormattedMessage} from "react-intl";

export const Support = () => {
    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const closeModal = () => setShow(false);

    return (
        <S.Container>
            <S.Content>
                <div>
                    <S.Image src={SupportImage}/>
                </div>
                <S.TextBlock>
                    <S.Title><FormattedMessage id="aboutSupportTitle"/></S.Title>
                    <Text1><FormattedMessage id="aboutSupportText1"/></Text1>
                    <S.Help><FormattedMessage id="aboutSupportTeleGuardId"/></S.Help>
                    <Button onClick={showModal}><FormattedMessage id="aboutSupportButton1"/></Button>
                </S.TextBlock>
            </S.Content>
            <SimpleModal show={show} close={closeModal} modalSize={ModalSize.small}>
                <S.ModalBody>
                    <S.QRCode src={QRCode} alt={'qr code'}/>
                    <S.ModalText><FormattedMessage id="aboutSupportTeleGuardId"/></S.ModalText>
                </S.ModalBody>
            </SimpleModal>
        </S.Container>
    )
}